import { call } from 'redux-saga/effects';
import { hashHistory } from 'react-router';

export function* navigateTo(params: string) {
  yield call(hashHistory.push, params);
}
